<template>
  <div style="width: 1080px">
    <core-user-info v-if="dataInfo.length == 1"  :dataInfo="dataInfo[0]" @addCoreUser="addCoreUser" @deleteCoreUser="deleteCoreUser" :hideDeleteBtn="true" @onMounted="addCoreUserRef" @onDestroy="removeCoreUserRef" :disabled="disabled"/>
    <el-tabs v-else v-model="tabValue" type="card" >
      <el-tab-pane
        v-for="(item, index) in dataInfo"
        :key="'coreUser' + index"
        :label="item.name ? item.name : `核心成员${index+1}`"
        :name="index + ''"
      >
        <core-user-info  :dataInfo="item" @addCoreUser="addCoreUser" @deleteCoreUser="deleteCoreUser" :showDeleteBtn="true" @onMounted="addCoreUserRef" @onDestroy="removeCoreUserRef" :disabled="disabled"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import {toast} from '@/utils'
import {findByKey, toList, CARD_TYPE, YES_OR_NO} from '@/constant/Enums'
import CoreUserInfo from '../coreUserInfo'

export default {
  components: {
    CoreUserInfo,
  },
  props: {
    dataInfo: {
      type: Array,
      default: ()=>{
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabValue: '0',
      coreUserRefs: [],
    }
  },
  watch: {
  },
  computed: {
  },
  created(){
  },
  mounted() {
  },
  methods: {
    addCoreUserRef(ref){
      this.coreUserRefs.push(ref);
    },
    removeCoreUserRef(ref){
      this.coreUserRefs.splice(this.coreUserRefs.indexOf(ref), 1);
    },
    addCoreUser(){
      this.dataInfo.push({
        workAndStudyList: [{}],//个人学习及工作履历
        zzqkList: [{}],//主持国家和地方科技业项目及资助情况
        coreSfzFileIdList:[],//身份证或护照
        xlxwFileIdList:[],//学历学位证书
        zczsFileIdList:[],//职称证书
        glcgFileIdList:[],//各类成果和奖项
      })
      this.tabValue = (this.dataInfo.length - 1) + '';

      window.scrollTo(0, 0);
    },
    deleteCoreUser(dataInfo){
      let tabIndex = parseInt(this.tabValue)
      let name = dataInfo.name ? dataInfo.name : `核心成员${tabIndex+1}`
      this.$confirm(`是否删除【${name}】信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(this.dataInfo.length > 1) {
          this.dataInfo.splice(tabIndex, 1)

          setTimeout(()=>{
            if(tabIndex >= this.dataInfo.length) {
              this.tabValue = (this.dataInfo.length - 1) + ''
            }
          })
          toast('删除成功')
        }

      });
    },
    validate(callback){
      let isValid = true
      this.coreUserRefs.forEach((ref, index)=>{

        ref.validate((valid, object) => {
          if(isValid && !valid) {
            isValid = false
            this.tabValue = index + ''
            callback && callback(valid, object)
          }
        });
      })
      if(isValid) {
        callback && callback(isValid, {})
      }
    },
    resetFields(){
      this.coreUserRefs.forEach((ref, index)=>{
        ref.resetFields();
      })
    }
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
